<div class="flex flex-col -m-6">

  <!-- Header -->
  <div
    class="flex flex-0 sticky -top-6 z-50 items-center justify-between h-16 pr-3 sm:pr-5 pl-6 sm:pl-8 bg-primary text-on-primary">
    <div class="text-lg font-medium">{{ 'goal.createGoal' | transloco }}</div>
    <button mat-icon-button (click)="closeDialog()" [tabIndex]="-1">
      <mat-icon class="text-current" svgIcon="heroicons_outline:x"></mat-icon>
    </button>
  </div>

  <!-- Content -->
  @for (taskTypeGoal of data.taskTypeGoals; track taskTypeGoal; let i = $index) {
    <div class="flex flex-col p-6">
      <span class="text-xl font-bold">{{ taskTypeGoal.caption | localize }}</span>
      @if (goalForm.controls[i]) {
        <form class="flex flex-col w-full" [formGroup]="goalForm.controls[i]">
          <div class="flex p-2 gap-4 mt-4">
            @if (taskTypeGoal.fromMaster) {
              <div class="w-1/2">
                <mat-form-field class="fuse-mat-no-subscript w-full">
                  <mat-label>{{ 'goal.concept' | transloco }}</mat-label>
                  <input type="text" matInput formControlName="masterOid" [matAutocomplete]="auto">
                  <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" [displayWith]="displayFn">
                    @for (option of (filteredOptionsByUri?.get(taskTypeGoal.masterUri) ?? []); track option.code) {
                      <mat-option [value]="option">{{ option.value | localize }}</mat-option>
                    }
                  </mat-autocomplete>
                </mat-form-field>
              </div>
            }
            <div class="flex items-center w-1/4">
              <mat-form-field class="fuse-mat-no-subscript w-full">
                <mat-label>{{ (taskTypeGoal.deliveryMode === 'UNITS' ? 'goal.units' : 'goal.percentage') | transloco }}</mat-label>
                <input type="number" class="text-right" matInput formControlName="goalValue">
              </mat-form-field>
              @if (taskTypeGoal.deliveryMode === 'PERCENT') {
                <span class="ml-4">%</span>
              }
            </div>
          </div>
        </form>
      }
    </div>
  }

  <!-- Actions -->
  <div class="flex flex-col sm:flex-row justify-end gap-2 px-4 pb-2 sm:px-8 sm:pb-8 w-full">
    <button (click)="closeDialog()" mat-stroked-button>
      {{ 'cancel' | transloco }}
    </button>
    <button (click)="save()" mat-flat-button color="primary">
      {{ 'save' | transloco }}
    </button>
  </div>
</div>